export default __webpack_public_path__ + "static/media/cp_geo_cv.771a63e8.svg";